// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","ProfileSideMenu":"jc_a bhj_st bhj_tp bhj_wo"};